import i18n from '@/lang/i18n'

export default [{
  path: '/admin/institution/filesList',
  name: 'InstitutionFilesList',
  component: () => import('@/views/institution/files/list'),
  meta: {
    title: i18n.t('router.files.files_list'),
    headType: 2,
    auth: true,
    routerType: 2
  }
}, {
  path: '/admin/institution/files/detail',
  name: 'InstitutionFilesDetail',
  component: () => import('@/views/institution/files/detail'),
  meta: {
    title: i18n.t('router.files.files_detail'),
    headType: 2,
    auth: true,
    routerType: 2
  }
}]



// WEBPACK FOOTER //
// ./src/router/institution/files.js